<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">Update Merchandise Color</div>
    </div>
    <div class="white-wrapper" style="zoom: 0.9">
      <form class="row">
        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="color_name"
                type="text"
                name="color_name"
                id="color_name"
              />
              <label>Color Name</label>
            </div>
          </div>
        </div>

        <div class="col-lg-1 col-xl-1 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material p-0">
              <input
                placeholder="."
                v-model="color_code"
                type="color"
                name="color_code"
                id="color_code"
                class="p-0 m-0"
              />
              <label>Color Code</label>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="color_description"
                type="text"
                name="color_description"
                id="color_description"
              />
              <label>Description</label>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">Active</label>
            <b-form-checkbox
              unchecked-value="N"
              value="Y"
              v-model="color_is_active"
              name="check-button"
              switch
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="merchandise-color"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      color_name: "",
      color_id: null,
      color_code: "",
      color_description: "",
      color_is_active: "Y",
      submitted: false,
    };
  },
  mounted() {},
  beforeMount() {
    const { color_id } = this.$route.query;
    if (color_id) {
      this.color_id = color_id;
      this.getItemsDetails(color_id);
    }
  },
  methods: {
    getItemsDetails(color_id) {
      let loader = this.$loading.show();
      let payload = {
        color_id: color_id,
      };
      MasterService.GetSingleMerchandiseColor(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records && data.Records.length > 0) {
            const {
              color_name,
              color_id,
              color_code,
              color_description,
              color_is_active,
            } = data.Records[0];
            this.color_name = color_name;
            this.color_code = color_code;
            this.color_description = color_description;
            this.color_id = color_id;
            this.color_is_active = color_is_active;
          } else {
            this.$toasted.show(data.message || "Unable to fetch data");
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    OnFinalSubmit: function (redirect) {
      this.submitted = true;
      if (!this.color_name) {
        return this.$toasted.show("Please Enter Color Name");
      } else if (!this.color_code) {
        return this.$toasted.show("Please Select Color");
      } else {
        let loader = this.$loading.show();
        let payload = {
          color_id: this.color_id,
          color_name: this.color_name,
          color_code: this.color_code,
          color_description: this.color_description,
          color_is_active: this.color_is_active || "Y",
        };
        MasterService.UpdateMerchandiseColor(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;
            if (data && data.status) {
              this.resetForm();
              if (redirect) {
                this.$router.push({
                  path: "merchandise-color",
                });
              }
              this.submitted = false;
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    resetForm: function () {
      this.color_id = null;
      this.color_name = "";
      this.color_Code = "";
      this.color_description = "";
      this.color_is_active = "Y";
      this.btenable = false;
      this.submitted = false;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MechandiseComponents/UpdateMerchandiseColor.vue